import React from 'react';
import {_GPY,__GPYPost} from '../env.js'

class LoginForm extends React.Component  {

		constructor(props) {
		 super(props);
		 this.state = {
						 password : "",
						 _password: false,
						 password_valid : "",
						 _password_valid: false,
						_fail: false,
					};
		 }
		 resetPassword(){
			 	__GPYPost('resetPassword',{confirmId:_GPY.confirmId,password:this.state.password},() => {
					 this.returnToLogin();
				});
		 }
		 setCurrentForm(f) {
			 console.log(f);
		     this.props.login.setCurrentForm(f);
		 }

		 isPasswordValid(e){
	     return this.state.password === e;
	   }

 	  onChange(name,validator,e) {
 	    console.log(name,validator,e);
 	      var s = this.state;
 	      s[name] = e.target.value;
 	      s["_" + name] = validator(s[name]);
 	      this.setState(s);
 	  }
		returnToLogin(){
			this.props.login.setCurrentForm("LoginForm");
		}

		 render () {
				    return (
				<div>
					   <div  className="jumbotron">
								 <div className="row">
								 		<div className="col"><h1 className="display-4">{_GPY.i18n.get('login_form_headLine')}</h1></div>
								 		<div className="col text-right"><img style={{maxWidth : '200px'}} src={_GPY.resource("images/guppyi_logo.png")} className="img-fluid mx-auto" alt="Guppyi Logo"/></div>
								 </div>

								 <p className="lead">{_GPY.i18n.get('login_form_subHeadLine')}</p>
								 <hr className="my-4"/>

									<div className="row">
										 <div className="col">
												<div className="form-group">
													<label htmlFor="register_password">{_GPY.i18n.get('register_form_input_password_title')}</label>
													<input  name="register_password"  onChange={this.onChange.bind(this,"password",_GPY.isValidPassword)}  value={this.state.password} type="password" className={!this.state._password&&this.state.password!==''?"form-control border border-danger":"form-control"} placeholder={_GPY.i18n.get('register_form_input_password_placeholder')}/>
													{!this.state._password&&this.state.password!==''?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_invalid_password')}</small>:""}
												</div>
										</div>
										<div className="col">
											<div className="form-group">
												 <label htmlFor="register_password_valid">{_GPY.i18n.get('register_form_input_password_repeat_title')}</label>
												 <input  name="register_password_valid" onChange={this.onChange.bind(this,"password_valid",this.isPasswordValid.bind(this))}  value={this.state.password_valid} className={!this.state._password_valid&&this.state.password_valid!==''?"form-control border border-danger":"form-control"} type="password" placeholder={_GPY.i18n.get('register_form_input_password_repeat_placeholder')}/>
												 {!this.state._password_valid&&this.state.password_valid!==''?<small className="form-text text-danger">{_GPY.i18n.get('from_validation_invalid_password_repeat')}</small>:""}
											 </div>
										</div>
								 </div>


								<div className="row">
								 	<div className="col">
								 		<button onClick={this.returnToLogin.bind(this)} className="btn btn-light btn-lg" >{_GPY.i18n.get('register_form_button_login')}</button>
								 	</div>
								 	<div className="col">
								 		<div className="float-right">

										{ this.state._password && this.state._password_valid?
											<button onClick={this.resetPassword.bind(this)} className="btn btn-success btn-lg">{_GPY.i18n.get('resetpassword_form_button_reset')}</button>
											:
												<button className="btn btn-primary btn-lg disabled">{_GPY.i18n.get('resetpassword_form_button_reset')}</button>
										}

								 		</div>
								 	</div>
								</div>

						</div>
					</div>
			  	)
		  }
}
export default LoginForm;
